import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISearchParams, ISearchResponse } from '../interfaces/search.interface';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private readonly http = inject(HttpClient);
  private readonly tenantService = inject(TenantService);

  public search(searchTerm: string, limit: number, lastEvaluatedKey?: string): Observable<ISearchResponse> {
    const body: ISearchParams = {
      tenant: this.tenantService.currentTenant(),
      language: 'en',
      searchTerm,
      limit
    };

    if (lastEvaluatedKey) {
      body.startKey = lastEvaluatedKey;
    }

    return this.http.post<ISearchResponse>(`${environment.api.backend}search`, body);
  }
}
